import React from "react";
import { useLocation } from "react-router-dom";
import AirportTicker from "@/components/AirportTicker";

// Main-menu pages that should show the airport-weather strip directly below the
// header. Everything else (member sub-pages like /documents, /phf, /settings,
// /profile, /inbox, membership funnel, payment success, auth pages, detail
// pages like /crew/:id, /forum/:tid, /operators/:id, legal pages, admin, …)
// intentionally omits the ticker so it stays a "landing chrome" element, not
// noise inside deep flows.
const TICKER_PATHS = new Set([
  "/",
  "/directory",
  "/aerointel",
  "/ai",
  "/jobs",
  "/contracts",
  "/aog",
  "/marketplace",
  "/forum",
  "/search",
  "/find-crew",
  "/hire-now",
  "/operators",
  "/quote",
  "/empty-leg",
  "/feed",
  "/unicom",
  "/fuel",
  "/aircraft-sales",
  "/digital-id",
  "/contact",
]);

export default function GlobalTicker() {
  const { pathname } = useLocation();
  // Normalize trailing slash so /jobs/ still matches /jobs.
  const p = pathname.length > 1 && pathname.endsWith("/") ? pathname.slice(0, -1) : pathname;
  if (!TICKER_PATHS.has(p)) return null;
  return <AirportTicker />;
}
